import { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  FormControl,
  Grid,
  Typography,
  TextField,
  Autocomplete,
} from "@mui/material";
import { createPushEvents, updatePushEvents } from "services/nodejs.service";

// import { createPushService } from "services/nodejs.service.ts";

const frequencyMap = [
  { id: 0, title: "1 vez a la semana" },
  { id: 1, title: "2 veces a la semana" },
  { id: 2, title: "3 veces a la semana" },
  { id: 3, title: "1 ves cada 2 semanas" },
  { id: 4, title: "cada inicio de mes" },
  { id: 5, title: "al fin de mes" },
];

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

type Props = {
  close: () => void;
  visible: boolean;
  pushFragments: any;
  refeshPush: () => void;
  toEdit: any;
};

function isEmpty(obj: any) {
  if (obj.reset) return true;
  return Object.keys(obj).length === 0;
}

function SinglePushModal({
  close,
  visible,
  refeshPush,
  pushFragments,
  toEdit,
}: Props) {
  const [minorModal, setMinorModal] = useState(false);
  const [name, setName] = useState("");
  const [sendingFrequency, setSendingFrequency] = useState<any>(null);
  const [channel, setChannel] = useState<undefined | number>(0);
  const [programs, setPrograms] = useState<null | string>("");
  const [pushes, setPushes] = useState<any>([]);
  const refreshModal = () => {
    setChannel(0);
    setPrograms("");
    setSendingFrequency(null);
    setPushes([]);
  };

  function returnShownFragments() {
    let pushToShow;
    if (channel && channel > 99) pushToShow = pushFragments.wa;
    else pushToShow = pushFragments.app;
    if (pushToShow == undefined) return {};
    return pushToShow;
  }
  const usablePushFragments = useMemo(
    () => returnShownFragments(),
    [pushFragments, channel]
  );

  useEffect(() => {
    console.log('toEdit', toEdit)
    if (!Object.keys(toEdit).length) {
      return;
    }
    if (toEdit.reset) {
      refreshModal();
      return;
    }
    setName(toEdit.name);
    setSendingFrequency(frequencyMap[toEdit.frequency])
    setChannel(toEdit.channel);
    setPrograms(toEdit.program_ids);
    if(toEdit.push_groups) {
        const key = toEdit.channel > 99 ? 'wa':'app'
        let temp = toEdit.push_groups.split(',').map(Number)
        console.log('>', temp)
        console.log('>', pushFragments[key])
        console.log('>', pushFragments[key].filter((el:any)=>temp?.includes(el.value)))
        setPushes(pushFragments[key].filter((el:any)=>temp?.includes(el.value)))
    }
  }, [toEdit]);

  async function createPush() {
    let pushToSend: any = {
      name: name,
      channel: channel,
      frequency: sendingFrequency.id,
    };
    if (programs && programs != "") pushToSend.program_ids = programs;
    if (!isEmpty(pushes))
      pushToSend.pushToSend = pushes.map((el: any) => el.value);
    let push;
    if (isEmpty(toEdit)) {
      push = await createPushEvents(pushToSend);
    } else {
      pushToSend.id = toEdit.id;
      push = await updatePushEvents(pushToSend);
    }
    if (push.status == 201) {
      sleep(1000);
      refeshPush();
      refreshModal();
      close();
    }
  }
  return (
    <Modal open={visible}>
      <form>
        <Box sx={modalStyle}>
          <Grid container>
            <Grid
              container
              spacing={1 / 2}
              style={{ display: "flex", flexDirection: "row" }}
              p={1}
            >
              <Grid item xs={12} p={1}>
                <TextField
                  label="Nombre de evento a mandar push"
                  value={name || null}
                  onChange={(el) => setName(el.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  id=""
                  options={frequencyMap}
                  value={sendingFrequency || null}
                  onChange={(v, nv: any) => setSendingFrequency(nv)}
                  getOptionLabel={(option) => option.title}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Frecuencia de envio"
                      placeholder=""
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel id="channel">Channel</InputLabel>
                  <Select
                    labelId="channel"
                    id="channel"
                    label="Channel"
                    value={channel}
                    onChange={(v) => {
                      setChannel(v.target.value as number);
                      setPrograms("");
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      APP POR PROGRAMA
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      APP BRAZIL
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      APP BOTNAR
                    </MenuItem>
                    <MenuItem key={3} value={50}>
                      AFINIAPP
                    </MenuItem>
                    <MenuItem key={4} value={100}>
                      WHATSAPP PROGRAMA
                    </MenuItem>
                    <MenuItem key={5} value={101}>
                      WHATSAPP BRAZIL
                    </MenuItem>
                    <MenuItem key={6} value={102}>
                      WHATSAPP BOTNAR
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {channel == 100 || channel == 0 ? (
              <Grid item xs={12} p={1}>
                <TextField
                  label="Program ids"
                  value={programs}
                  onChange={(el) => setPrograms(el.target.value)}
                  fullWidth
                />
              </Grid>
            ) : null}
          </Grid>
          <Grid item xs={12} p={1}>
            {/* /#1 */}
            <Autocomplete
              multiple
              id=""
              options={usablePushFragments}
              value={pushes}
              onChange={(v, nv) => setPushes(nv)}
              getOptionLabel={(option: any) => option.label}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} label="Pushes a enviar" placeholder="" />
              )}
            />
          </Grid>
          <Grid container>
            <Grid item xs={6} p={1}>
              <Button variant="contained" fullWidth onClick={createPush}>
                {isEmpty(toEdit) ? "Agregar" : "Editar"}
              </Button>
            </Grid>
            <Grid item xs={6} p={1}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  refreshModal();
                  close();
                }}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Modal open={minorModal}>
          <Box sx={minorStyle}>
            <Grid container flexDirection={"row"}>
              <Grid container p={1}>
                <Grid item>
                  <Typography variant="h6" color={"black"}>
                    Error al guardar push.
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    onClick={() => setMinorModal(false)}
                  >
                    Cerrar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </form>
    </Modal>
  );
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "white",
  p: 4,
  display: "flex",
  flexDirection: "column",
  transform: "translate(-50%, -50%)",
  minWidth: "70%",
};

const minorStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "white",
  p: 4,
  display: "flex",
  flexDirection: "column",
  transform: "translate(-50%, -50%)",
  // minWidth:'70%'
};

export default SinglePushModal;
